/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'
import { RaisedButton } from 'material-ui'

import AlertModal from 'generic/dialog/AlertModal'
import LoadingDialog from 'generic/dialog/LoadingDialog'

import BaseValidation from 'components/common/BaseValidation'

import { messages } from 'constants/messages'
import * as actions from 'actions/ApplicantPrestation'

class PrestationValidation extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)
   
    this.state = {
      open: false,
      loading: true,
      errors: {
        errorMessage: undefined,
        errorFields: {}
      },
      message: undefined,
      send: false,
    }
  }

  componentDidMount() {
    actions.getPrestationValidationDistance(this.props.match.params.token)
      .then((result) => {
        this.setState({
          open: true,
          message: this.props.intl.formatMessage(messages.PRESTATION_VALIDATION_DISTANCE, {
          	id: result.data.object.id,
          })
        })
      })
      .catch((error) => {
        if (error && error.status === 404) {
          this.setState({
            errors: {
              ...this.state.errors,
              errorMessage: error.data.errors[0].user_message,
            },
          })
        }
      })
      .finally(() => {
        this.setState({
          loading: false
        })
      })
  }

  handleConfirm() {
    this.setState({
      loading: true
    })

    actions.postPrestationValidationDistance(this.props.match.params.token)
      .then((result) => {
        this.setState({
          send: true,
        })
      })    
      .catch((error) => {
        if (error && error.status === 404) {
          this.setState({
            errors: {
              ...this.state.errors,
              errorMessage: error.data.errors[0].user_message,
            },
          })
        }
      })
      .finally(() => {
        this.setState({
          open: false,
          loading: false
        })
      })
  }

  handleLogin() {
    this.props.history.push({pathname: '/login/'})
  }

  render () {
    return (
    	<BaseValidation>
        {
          this.state.loading
            ? <LoadingDialog/>
            : <React.Fragment>
              {
                this.state.errors.errorMessage
                  ? <div
                    style={{...styles.message,...{color: 'red'}}}
                  >
                    { this.state.errors.errorMessage }
                  </div>
                  : <React.Fragment>
                    {
                      this.state.send
                        ? <div style={styles.message}>
                          <div className='row'>
                          	{this.props.intl.formatMessage(messages.PRESTATION_VALIDATION_SEND)}
                          </div>
                          <RaisedButton
                            label={this.props.intl.formatMessage(messages.BACK_TO_LOGIN)}
                            primary={true}
                            style={{marginTop: 5}}
                            onClick={this.handleLogin}
                          />
                        </div>
                        : <AlertModal
                          modal={true}
                          open={this.state.open}
                          title={this.props.intl.formatMessage(messages.PRESTATION_VALIDATION_TITLE)}
                          type={AlertModal.CONFIRM}
                          handleConfirm={this.handleConfirm}
                        >
                          <div style={{textAlign: 'center'}}>
                            {this.state.message}
                          </div>
                        </AlertModal>
                    }
                  </React.Fragment>
              }
            </React.Fragment>
        }    	
    	</BaseValidation>
    )	
  }
}

const styles = {
  message: {
    color: '#5d5d5d',
    fontWeight: 300,
    fontSize: '1.25rem',
    textAlign: 'center'
  }
}

export default injectIntl(PrestationValidation)



// WEBPACK FOOTER //
// ./src/components/applicant/PrestationValidation.js